/* eslint-disable max-len */
import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    globalVariables: [],
    vitalInfo: [],
    countryCodes: [],
    filterState: [],
    location_key: '',
    viewOrgUser: '',
    restrict: false,
    viewPatient:'',
    messageSent:false,
    editingUserId:''
}

const SystemConfigSlice = createSlice({

    name: 'SystemConfig',
    initialState,
    reducers: {
        handleSystemConfig: (state, action) => {
            state.globalVariables = action.payload.global_variables
            state.vitalInfo = action.payload.vital_information
        },
        handleAddCountryCodes: (state, action) => {
            state.countryCodes = action.payload
        },
        resetState:(state) => {
            state.globalVariables = []
            state.vitalInfo = [],
            state.restrict = false,
            state.countryCodes = [],
            state.messageSent=false,
            state.editingUserId=''
        },
        handleAddFilterValues: (state, action) => {
            state.filterState = action.payload
        },
        handleIsViewScreen: (state, action) => {
            state.viewToHistory = action.payload[0]
        },
        resetFilterState: (state) => {
            state.filterState = []
        },
        handleLocationKey: (state, action) => {
            state.location_key = action.payload
        },
        handleViewUserScreen: (state, action) => {
            state.viewOrgUser = action.payload[0]
        },
        handleRestrictKey: (state, action) => {
            state.restrict = action.payload
        },
        handleEditMessageSent: (state, action) => {
            state.messageSent = action.payload; // Otherwise, update with the provided payload
        },        
        handleTargetUserEditId:(state,action)=>{
            state.editingUserId=action.payload
        },
        handleSidebarPrvState:(state,action)=>{
            state.sidebarPrvState=action.payload
        }

    },

})
export const { handleTargetUserEditId,handleEditMessageSent,handleRestrictKey, handleSystemConfig, handleIsUserScreen, handleAddCountryCodes, resetState, handleAddFilterValues, handleIsViewScreen, handleViewUserScreen, resetFilterState, handleSidebarPrvState } = SystemConfigSlice.actions;
export default SystemConfigSlice.reducer